export const getSizeStyles = (size) => {
  switch (size) {
    case 'sm': return { width: '400px' };
    case 'lg': return { width: '800px' };
    case 'md':
    default: return { width: '600px' };
  }
};

export const buildModalAriaProps = (title) => {
  if (title) {
    return {
      'aria-labelledby': 'modal-title',
      'aria-modal': 'true',
      role: 'dialog'
    };
  }
  return {
    'aria-modal': 'true',
    role: 'dialog'
  };
};



// WEBPACK FOOTER //
// ./src/design-system/molecules/Modal/utils/modalHelpers.js